function getEan(product) {
  if (!product) return null;
  if (product.ean) return product.ean;
  if (typeof product.slug === 'string' && product.slug.length) {
    const match = product.slug.match(/\b\d{10,13}\b/);
    if (match) return match[0];
  }
  return null;
}

export default getEan;
